import { handleValidation } from "./validation.js";
import '../utils/altcha.min.js';

const handleFormSubmit =  () => {
    function formSubmit() {
        const forms = document.querySelectorAll('.js-sk-form');
        forms.forEach((form) => {
          const message = form.nextElementSibling;
          const submit = form.querySelector('button[type=submit]');
          const loader = form.previousElementSibling;

          const startInput = form.querySelector('input[name="form_start"]');
          if (startInput) startInput.value = Date.now();

          // Run validation on click so errors appear immediately.
          // ALTCHA registers a capture-phase submit listener that calls stopPropagation()
          // while unverified, which blocks our submit handler on first click.
          submit.addEventListener('click', (e) => {
            if (!handleValidation(form)) {
              e.preventDefault()
            }
          })

          form.addEventListener('submit', function(e){
            e.preventDefault()

            // ALTCHA hasn't solved the PoW yet — auto="onsubmit" will solve then
            // call form.requestSubmit(), which re-fires this handler with the value set
            const altchaInput = form.querySelector('input[name="altcha"]');
            if (!altchaInput || !altchaInput.value) {
              return
            }

            submit.setAttribute('disabled', true)
            loader.classList.remove('hidden')

            const formData = new FormData(this);
            fetch(themeVars.ajax_url, {
              method: "POST",
              body: formData,
              headers: {
                "X-Requested-With": "XMLHttpRequest",
              },
            })
            .then((response) => {
              if (!response.ok) throw new Error("Network response was not ok");
              return response.json();
            })
            .then((data) => {
              submit.removeAttribute('disabled')
              loader.classList.add('hidden')
              if (data.success) {
                message.innerText = data.message;
                setTimeout(() => {
                  form.remove();
                  message.classList.remove('hidden');
                }, 300)
              } else {
                message.innerText = data.data || data.message || 'Something went wrong. Please try again.';
                message.classList.remove('hidden');
              }
            })
            .catch((error) => {
              console.error("There was a problem with the fetch operation:", error);
              submit.removeAttribute('disabled')
              loader.classList.add('hidden')
            });
          })
        })
      }

    return {
        init() {
            formSubmit()
        },
    }
}


export {
    handleFormSubmit,
};
